import axios from "axios";
import { authHeaderJson } from "../auth-header.service";

const getListPartieTypes = () => {
    return axios.get(`/api/Partida/partieType/list`, { headers: authHeaderJson() } )
};

const getPartieTypeById = (partieTypeId) => {
        return axios.get(`/api/Partida/partieType/${partieTypeId}`, { headers: authHeaderJson() } );
};

const addPartieType = (partieType) => {
    return axios.post(`/api/Partida/partieType/add/`, partieType, { headers: authHeaderJson() } );
}

const addPartieTypeList = (partieTypes) => {
    return axios.post(`/api/Partida/partieType/add/list`, partieTypes, { headers: authHeaderJson() } );
}

const savePartieTypeById = (partieTypeId, objContract) => {
    return axios.put(`/api/Partida/partieType/${partieTypeId}`, objContract, { headers: authHeaderJson() });
};

const deletePartieType = (partieTypeId) => {
    return axios.delete(`/api/Partida/partieType/${partieTypeId}`, { headers: authHeaderJson() });
}

export {
    getListPartieTypes,
    getPartieTypeById,
    addPartieType,
    addPartieTypeList,
    savePartieTypeById,
    deletePartieType
}